import { configureStore } from "@reduxjs/toolkit";
import * as reducers from "./reducers"; // this can sometimes have problems with "gatsby develop" caching all files (.cache) and not reloading them properly - may need to manually list them out
import collectionItemSlice from "./reducers/collectionItemSlice";
import collectionItemProfileSlice from "./reducers/collectionItemProfileSlice";

// NOTE: "Avoid Putting Form State In Redux" (https://redux.js.org/style-guide#avoid-putting-form-state-in-redux)

const reducer = {
    collectionItem: collectionItemSlice,
    collectionItemProfile: collectionItemProfileSlice,
    ...reducers, // legacy
};

delete reducer.CollectionItemSlice;

export const store = configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});
